import {UserQuery} from "../graphql-types";

export const AsAcKey = (userInfo: UserQuery | undefined, key?: string) => {
    if (key && userInfo) {
        const lenNum =
            userInfo.user?.companySettings?.pantheonAnDocKeyLenNumber ?? 6;
        const docNum = lenNum == 6 ? 3 : 4;
        return `${key.slice(0, 2)}-${key.slice(2, 2 + docNum)}-${key.slice(2 + 2 + docNum)}`;
    }
};

export const AsOurKey = (userInfo: UserQuery | undefined, key?: string) => {
    // first four characters are the year
    // next n variable characters are number of company
    // maybe its best to just take 10 last numbers and thats the document increment
    // whats left in the middle is the company ID
    if (key && userInfo) {
        const year = key.slice(0, 4);
        const yearSuffix = year.slice(2, 4);
        const documentNumber = key.slice(-6);
        const companyId = key.slice(4, key.length - 10);
        return `${parseInt(year)}-${parseInt(companyId)}-${documentNumber}`;
    }
};
